export default {
  'National address lookup failed': 'National address lookup failed',
  'You may upload a National Address Certificate, or continue without it. Our team will review your national address.':
    'You may upload a National Address Certificate, or continue without it. Our team will review your national address.',
  'National Address Certificate': 'National Address Certificate',
  'National Address Certificate upload failed': 'Unable to upload the National Address Certificate. Please try again.',
  // Header
  'Application Number :': 'Application Number :',

  // Company Information step
  'review.contractReview': 'Agreement',
  'Nafath Verification': 'Nafath Verification',
  'Application Rejected': 'Application Rejected',
  'Company Information': 'Company Information',
  'Company Legal name': 'Company Legal name',
  'Please share basic details about the company you represent.':
    'Please share basic details about the company you represent.',
  'Date of establishment': 'Date of establishment',
  'Company legal type': 'Company legal type',
  'Company commercial name': 'Company commercial name',
  'Commercial registration number': 'Commercial registration number',
  'Commercial entity number': 'Commercial entity number',
  'License authority': 'License authority',
  'License issue date': 'License issue date',
  'License expiry date': 'License expiry date',
  'Tax registration certificate': 'Tax registration certificate',
  'Yes, I have a Tax registration certificate.': 'Yes, I have a Tax registration certificate.',
  'Please upload the Tax registration certificate photo.':
    'Please upload the Tax registration certificate photo.',
  'Tax registration number': 'Tax registration number',
  'Tax Registration Number': 'Tax Registration Number',
  'Document data:': 'Document data:',
  'Passport data:': 'Passport data:',
  'Passport data': 'Passport data',
  'Passport number': 'Passport number',
  'Parent company license number': 'Parent company license number',
  'Select main company activity': 'Select main company activity',
  'I want to change a business address': 'I want to change a business address',
  'If your address details are incorrect or incomplete, check this box to manually enter the correct information.':
    'If your address details are incorrect or incomplete, check this box to manually enter the correct information.',
  'Company email': 'Company email',
  'Select main business nature category': 'Select main business nature category',
  'Select main business nature': 'Select main business nature',
  COMPANY_NOT_ACTIVE: 'CR Number not found in official records.',
  'Unable to validate your details right now. Please try again later.':
    'Unable to validate your details right now. Please try again later.',
  COMPANY_RELATION: 'National ID / Iqama is not associated with the company structure.',
  MOBILE_VERIFICATION_NOT_OWNER: 'Mobile number is not associated with the provided National ID / Iqama',
  MOBILE_VERIFICATION_INVALID_NUMBER: 'Number not registered under ID.',
  MOBILE_VERIFICATION_INVALID_ID: 'Number not registered under ID.',
  // National ID/Iqama validation messages
  'Please enter 10 digits valid ID/Iqama number.': 'Please enter 10 digits valid ID/Iqama number.',
  'Please enter numbers only.': 'Please enter numbers only.',
  'National ID/Iqama is not associated with the company structure.':
    'National ID / Iqama is not associated with the company structure.',
  'National ID / Iqama is not associated with the company structure.':
    'National ID / Iqama is not associated with the company structure.',
  // Mobile number validation messages
  'Please enter a valid mobile number.': 'Please enter a valid mobile number.',
  'Mobile number is not associated with the provided National ID / Iqama': 'Mobile number is not associated with the provided National ID / Iqama',
  // Unified National Number validation messages
  'Please enter a valid 10-digit Unified National Number starting with (7).': 'Please enter a valid 10-digit Unified National Number starting with (7).',
  // Nature of Business validation messages
  'Please enter your business activity.': 'Please enter your business activity.',
  // Authorized signatory messages
  'Please select at least one authorized signatory.': 'Please select at least one authorized signatory.',
  'Please upload authorized signatory proof.': 'Please upload authorized signatory proof.',
  // Email and PEP validation messages
  'Please enter your email address.': 'Please enter your email address.',
  'Please provide the name of the Politically Exposed Person (PEP).': 'Please provide the name of the Politically Exposed Person (PEP).',
  // Address step
  Address: 'Address',
  'This must be the location where you will take payments and where we can reach you.':
    'This must be the location where you will take payments and where we can reach you.',
  Country: 'Country',
  Location: 'Location',
  'Address line': 'Address line',
  'P.O. Box': 'P.O. Box',
  'Office phone number': 'Office phone number',
  'Fax number': 'Fax number',
  'Additional phone number': 'Additional phone number',
  'Additional fax number': 'Additional fax number',
  'View location': 'View location',
  City: 'City',

  // Managers step
  // stagePayload?.activeStep.stepName
  Manager: 'Manager',
  Managers: 'Managers',
  'Please review the details of the managers of your company.':
    'Please review the details of the managers of your company.',
  'At least one person must have the authority and proof to act as an authorised signatory for your company.':
    'At least one person must have the authority and proof to act as an authorised signatory for your company.',
  'This person is a Politically Exposed Person (PEP)':
    'This person is a Politically Exposed Person (PEP)',
  'This person is authorised signatory': 'This person is authorised signatory',
  'A PEP is an individual who holds a prominent public position or has held one in the recent past, making them susceptible to potential corruption and money laundering risks. PEPs include high-ranking government officials, their immediate family members, and close associates.':
    'A PEP is an individual who holds a prominent public position or has held one in the recent past, making them susceptible to potential corruption and money laundering risks. PEPs include high-ranking government officials, their immediate family members, and close associates.',
  'ID type': 'ID type',
  'Document Number': 'Document Number',
  'ID number': 'ID number',

  // Shareholders step
  'Add beneficial owner': 'Add beneficial owner',
  'Edit beneficial owner': 'Edit beneficial owner',
  'Personal data': 'Personal data',
  'First name': 'First name',
  'Last name': 'Last name',
  'Date of birth': 'Date of birth',
  Nationality: 'Nationality',
  'Beneficial owner is a Politically Exposed Person (PEP)':
    'Beneficial owner is a Politically Exposed Person (PEP)',
  Passport: 'Passport',
  'Document number': 'Document number',
  'Passport issue date': 'Passport issue date',
  'Passport expiry date': 'Passport expiry date',
  'Personal document': 'Personal document',
  'Personal Document': 'Personal Document',
  'Personal document data:': 'Personal document data:',
  'Document type': 'Document type',
  'Ownership share': 'Ownership share',
  'Please specify ownership share': 'Please specify ownership share',
  'Shares, %': 'Shares, %',
  'Beneficial owners': 'Beneficial owners',
  'Because shares are held by a Legal entity as disclosed in the above section, please provide the details of Beneficial owners of the entity.':
    'Because shares are held by a Legal entity as disclosed in the above section, please provide the details of Beneficial owners of the entity.',
  'Individual Shareholder': 'Individual Shareholder',
  'Ownership share:': 'Ownership share:',
  'Shares count': 'Shares count',
  'Full name': 'Full name',
  Signatory: 'Signatory',
  PEP: 'PEP',
  'Legal name': 'Legal name',
  'CR number / Entity number': 'CR number / Entity number',
  'Legal Entity shareholder': 'Legal Entity shareholder',
  'Company Brand Name': 'Brand Name',
  'Brand Name': 'Brand Name',
  'Company Website': 'Company Website',
  'Nature of Business or Main Line of Business': 'Nature of Business or Main Line of Business',
  'Please enter your brand name': 'Please enter your brand name',
  'Please enter your brand name in english': 'Please enter your brand name in English',
  'Please enter your company website.': 'Please enter your company website.',
  'Please enter a valid website URL (e.g., example.com)': 'Please enter a valid website URL (e.g., example.com)',
  'Website URL exceeds the maximum allowed length of 255 characters. Please enter a shorter URL.':
    'Website URL exceeds the maximum allowed length of 255 characters. Please enter a shorter URL.',
  'Please enter your Nature of Business or Main Line of Business':
    'Please enter your Nature of Business or Main Line of Business',
  // Business Details Modification — new field labels
  'Business Details': 'Business Details',
  'Review & Confirm': 'Review & Confirm',
  'Check and confirm your data.': 'Check and confirm your data.',
  // Products Summary keys
  'Products Summary': 'Products Summary',
  'Product': 'Product',
  'No of Products': 'No of Products',
  'No of Terminals': 'No of Terminals',
  'E-commerce': 'E-commerce',
  'POS Terminal': 'POS Terminal',
  'POS terminal': 'POS Terminal',

  'Merchant Name (English)': 'Merchant Name (English)',
  'Merchant Name (Arabic)': 'Merchant Name (Arabic)',
  'Store Address (English)': 'Store Address (English)',
  'Store Address (Arabic)': 'Store Address (Arabic)',
  'Please enter your merchant name in English': 'Please enter your merchant name in English',
  'Please enter your merchant name in Arabic': 'Please enter your merchant name in Arabic',
  'Please enter your company name.': 'Please enter your company name.',
  'Please enter store address in English': 'Please enter store address in English',
  'Please enter store address in Arabic': 'Please enter store address in Arabic',
  'Please enter your city': 'Please enter your city',
  'Input should be in English': 'Input should be in English',
  'Input should be in Arabic': 'Input should be in Arabic',
  'Company Website URL': 'Company Website URL',
  'Select City': 'Select City',
  'Select': 'Select',
  'Please Select': 'Please Select',
  'Please enter the company website in the following format:':
    'Please enter the company website in the following format:',
  'https://www.domain.com or https://domain.com': 'https://www.domain.com or https://domain.com',
  'Please enter the full English address (district and street name). This address will be used for POS device delivery.':
    'Please enter the full English address (district and street name). This address will be used for POS device delivery.',
  'Enter your store or brand name (shown on receipts and SMS)': 'Enter your store or brand name (shown on receipts and SMS)',
  'Please enter the full Arabic address (district and street name). This address will be used for POS device delivery.':
    'Please enter the full Arabic address (district and street name). This address will be used for POS device delivery.',
  'Please enter a valid tax registration number': 'Please enter a valid tax registration number',
  'Please select Authorized Signatory Proof': 'Please select Authorized Signatory Proof',
  'Please enter your email': 'Please enter your email',
  'Please enter your mobile number': 'Please enter your mobile number',
  'Please enter a valid mobile number': 'Please enter a valid mobile number',
  'Supported files: JPG, JPEG, PNG, PDF.': 'Supported files: JPG, JPEG, PNG, PDF.',
  'Maximum size: {{size}}.': 'Maximum size: {{size}}.',
  'Files supported: JPG, JPEG, PNG, PDF. Max size {{size}}':
    'Files supported: JPG, JPEG, PNG, PDF. Max size {{size}}',
  'Please provide a Name of PEP': 'Please provide a Name of PEP',
  'Company license': 'Company license',
  'Company legal name': 'Company legal name',
  'Commercial Registration number': 'Commercial Registration number',
  'Entity number': 'Entity number',
  'Review shareholders': 'Review shareholders',
  'Please review all shareholders of your company.':
    'Please review all shareholders of your company.',
  'Individual shareholders': 'Individual shareholders',
  'Legal entity shareholders': 'Legal entity shareholders',
  'Country of incorporation': 'Country of incorporation',
  'Shareholder Proof Document': 'Shareholder Proof Document',
  MEMORANDUM: 'Memorandum of Association',
  ARTICLES: 'Articles of Association',
  'Minutes of board meetings': 'Minutes of board meetings',
  'Please upload a scan or a photo of Minutes of Board Meetings':
    'Please upload a scan or a photo of Minutes of Board Meetings',
  'Data of joint-stock companies listed in the financial market':
    'Data of joint-stock companies listed in the financial market',
  'Please upload a scan or a photo of Data of joint-stock companies listed in the financial market':
    'Please upload a scan or a photo of Data of joint-stock companies listed in the financial market',

  // Questionnaire step
  'Company Questionnaire': 'Company Questionnaire',
  'Please share additional information about your business.':
    'Please share additional information about your business.',
  'Company information': 'Company information',
  'Expected turnover': 'Expected turnover',
  Declaration: 'Declaration',
  'Additional documents': 'Additional documents',
  'Sama license': 'Sama license',
  'Please upload the SAMA license photo': 'Please upload the SAMA license photo',
  'Document number:': 'Document number:',
  'License number': 'License number',
  'AML policy and procedure': 'AML policy and procedure',
  'Please upload the AML policy and procedure document':
    'Please upload the AML policy and procedure document',
  'Compliance Clearance Certificate': 'Compliance Clearance Certificate',
  'Please upload the Compliance Clearance Certificate':
    'Please upload the Compliance Clearance Certificate',
  '*Sanctioned countries – Iran, Syria, Cuba, North Korea, Myanmar (Burma), Crimea (Ukraine) and any other countries/territories as updated time to time by the relevant authorities.':
    '*Sanctioned countries – Iran, Syria, Cuba, North Korea, Myanmar (Burma), Crimea (Ukraine) and any other countries/territories as updated time to time by the relevant authorities.',
  'Company website URL': 'Company website URL',
  'Number of employees': 'Number of employees',
  'The reason for applying for payment services': 'The reason for applying for payment services',
  'Do you have any established branch?': 'Do you have any established branch?',
  Yes: 'Yes',
  No: 'No',
  'Please specify the countries and the locations of your branches':
    'Please specify the countries and the locations of your branches',
  'Do you require tokenization?': 'Do you require tokenization?',
  'Do you hold any position from the below list of categories?':
    'Do you hold any position from the below list of categories?',
  'Please provide details:': 'Please provide details:',
  'Enter text here': 'Enter text here',
  'Indicate at least one Manager, Individual Shareholder or Beneficial Owner as a PEP person.':
    'Indicate at least one Manager, Individual Shareholder or Beneficial Owner as a PEP person.',
  'Is your company directly or indirectly owned/managed by a natural person residing in a sanctioned country*?':
    'Is your company directly or indirectly owned/managed by a natural person residing in a sanctioned country*?',
  'Specify the name of the sanctioned countries:': 'Specify the name of the sanctioned countries:',
  'Does your company perform business / transactions on behalf of a third party?':
    'Does your company perform business / transactions on behalf of a third party?',
  'Is your company registered or incorporated in a sanctioned country?':
    'Is your company registered or incorporated in a sanctioned country?',
  'Does your company have any subsidiary, branch, office or other presence in a sanctioned country?':
    'Does your company have any subsidiary, branch, office or other presence in a sanctioned country?',
  'Specify the sanctioned country and nature of business/operations:':
    'Specify the sanctioned country and nature of business/operations:',
  'Does your company own any assets in a sanctioned country?':
    'Does your company own any assets in a sanctioned country?',
  'Does your company trade with the US or in goods that are US origin or in part contain goods of US origin?':
    'Does your company trade with the US or in goods that are US origin or in part contain goods of US origin?',
  'Does your company maintain any relationship with financial institution in a sanctioned country?':
    'Does your company maintain any relationship with financial institution in a sanctioned country?',
  'Financial performance and projection': 'Financial performance and projection',
  'These are the values in SAR of expected financial performance':
    'These are the values in SAR of expected financial performance',
  'Expected average per transaction': 'Expected average per transaction',
  'Expected average per month': 'Expected average per month',
  'Expected six-month average credit balance': 'Expected six-month average credit balance',
  'Expected sales value turnover per year': 'Expected sales value turnover per year',
  'Expected number of transactions': 'Expected number of transactions',
  'These are the numbers of expected turnover': 'These are the numbers of expected turnover',
  'Expected monthly transactions': 'Expected monthly transactions',
  'Expected sales volume turnover per year': 'Expected sales volume turnover per year',
  'A natural person who is or has been entrusted with prominent public functions including:':
    'A natural person who is or has been entrusted with prominent public functions including:',
  'a head of state, head of government, minister or deputy or assistant minister;':
    'a head of state, head of government, minister or deputy or assistant minister;',
  'a senior government official; ': 'a senior government official; ',
  'a member of parliament;': 'a member of parliament;',
  'a senior politician;': 'a senior politician;',
  'an important political party official;': 'an important political party official;',
  'a senior judicial official;': 'a senior judicial official;',
  'a member of a court of auditors or the board of a central bank;':
    'a member of a court of auditors or the board of a central bank;',
  'an ambassador, charge d’affaires or other high-ranking officer in a diplomatic service; ':
    'an ambassador, charge d’affaires or other high-ranking officer in a diplomatic service; ',
  'a high-ranking officer in an armed force;': 'a high-ranking officer in an armed force;',
  'a senior member of an administrative, management or supervisory body of a state-owned enterprise;':
    'a senior member of an administrative, management or supervisory body of a state-owned enterprise;',
  'Any of the following family members of the above, including:':
    'Any of the following family members of the above, including:',
  'a spouse;': 'a spouse;',
  'a partner considered by national law as equivalent to a spouse;':
    'a partner considered by national law as equivalent to a spouse;',
  'a child': 'a child',

  // E-commerce service translations
  'e-commerceSubTitle': 'Trusted by Leading Online Merchants Across the Region.',
  'e-commerceLongDescription':
    "Accept secure payments online through your website or app, whether you're selling locally or globally.",
  'e-commerceBenefits':
    'Simple integration via API, plugins, hosted checkout, or mobile SDK \n Accepts cards, mobile wallets, and local payment methods \n Real-time reporting, fraud tools, and settlement tracking \n Sandbox environment for testing before going live. \n Designed for growing SMEs and large enterprises alike',

  // POS service translations — modal content
  'posSubTitle': 'Smart POS payments for your business',
  'posLongDescription':
    "Accept fast, secure, and reliable in-store payments with Network International's advanced POS solutions. Designed for Saudi, our POS enables merchants to accept local and international payment methods while providing full visibility and control over transactions.",
  'posBenefits':
    'Accept major payment methods, including card schemes (mada, Visa, Mastercard, Discover, GCC cards) and digital wallets such as Apple Pay and Samsung Pay.\nFast and secure in-store payment processing for a smooth checkout experience\nReal-time transaction monitoring and reporting\nEasy settlement tracking and reconciliation\nReliable infrastructure aligned with local regulatory requirements (SAMA)\nScalable solution supporting retailers, SMEs, and growing businesses across Saudi Arabia',

  // Aliases for legacy type = "nGeniusPos" (existing API response)
  'nGeniusPosSubTitle': 'Smart POS payments for your business',
  'nGeniusPosLongDescription':
    "Accept fast, secure, and reliable in-store payments with Network International's advanced POS solutions. Designed for Saudi, our POS enables merchants to accept local and international payment methods while providing full visibility and control over transactions.",
  'nGeniusPosBenefits':
    'Accept major payment methods, including card schemes (mada, Visa, Mastercard, Discover, GCC cards) and digital wallets such as Apple Pay and Samsung Pay.\nFast and secure in-store payment processing for a smooth checkout experience\nReal-time transaction monitoring and reporting\nEasy settlement tracking and reconciliation\nReliable infrastructure aligned with local regulatory requirements (SAMA)\nScalable solution supporting retailers, SMEs, and growing businesses across Saudi Arabia',

  // POS API field name keys
  'POS.name': 'POS',
  'POS.header': 'POS',
  'POS.short': 'Accept all major cards and wallets at your physical store',
  'POS.long': "Accept fast, secure, and reliable in-store payments with Network International's advanced POS solutions.",
  'POS.monthlyFee': 'Monthly fee',
  'POS.setupFee': 'Setup fee',
  'POS.terminalFee': 'Terminal fee',
  'POS.madaLessThan100': 'mada transactions less than {SAR}100',

  'POS.madaLessThan100.description': 'Applicable on mada transactions below SAR 100',
  'POS.madaEqualOrAbove100': 'mada transactions {SAR}100 or above',
  'POS.madaEqualOrAbove100.description': 'Applicable on mada transactions SAR 100 and above',
  'POS.creditcard': 'Credit card per transaction',
  'POS.gcc': 'GCC Card Fee',
  'POS.minimumUsageFee': 'Minimum usage fee per POS device',
  'POS.minimumUsageFee.description': 'If the monthly sales value below {SAR}15,000',
  'POS.fundsTransferFee': 'Funds transfer fee',
  'POS.vat': 'VAT',
  'POS.maxTerminals': 'Max terminals',
  'POS.currencyLimit': 'Currency limit',

  // eCommerce fee fields
  'eCommerce.monthlyFee': 'Monthly fee',
  'eCommerce.setupFee': 'Setup fee',
  'eCommerce.setupFees': 'Setup fee',
  'eCommerce.creditcard': 'Credit card (per transaction)',
  'eCommerce.fundsTransferFee': 'Funds Transfer Fees',
  'eCommerce.madaPricing': 'mada (per transaction)',

  // POS fee display helpers
  'capped at': 'capped at',
  'Number of Terminals': 'Number of Terminals',

  // API label strings — SAR token kept so renderTextWithSarIcon replaces it with the icon
  'mada less than SAR 100': 'mada less than SAR 100',
  'mada equal SAR 100 or above': 'mada equal SAR 100 or above',
  'GCC Card Fee': 'GCC Card Fee',
  'Minimum usage fee per POS device': 'Minimum usage fee per POS device',
  'If the monthly sales value below SAR 15,000': 'If the monthly sales value below SAR 15,000',
  'mada equal or above SAR 100': 'mada equal or above SAR 100',
  'Funds Transfer Fee': 'Funds Transfer Fee',

  // Bank account step
  'Bank account': 'Bank account',
  'Account for E-commerce': 'Account for E-commerce',
  'Please upload a scan of stamped IBAN letter.': 'Please upload a scan of stamped IBAN letter.',
  'Stamped IBAN Letter': 'Stamped IBAN Letter',
  'Please share bank account details. The account must belong to specified company.':
    'Please share bank account details. The account must belong to specified company.',
  'Beneficiary full name': 'Beneficiary full name',
  'Bank name': 'Bank name',
  'In case of complex ownership structure please provide comments and/or schemas that might be relevant.':
    'In case of complex ownership structure please provide comments and/or schemas that might be relevant.',
  'Additional information': 'Additional information',
  'Additional Information': 'Additional Information',
  'ADDITIONAL INFORMATION': 'ADDITIONAL INFORMATION',
  // Review & submit step
  'Review & Submit': 'Review & Submit',
  'Termination reason': 'Termination reason',
  'Please select each tab to review the information before submitting the application.':
    'Please select each tab to review the information before submitting the application.',
  'To make changes, go to the appropriate section.':
    'To make changes, go to the appropriate section.',
  'Commercial name': 'Commercial name',
  'Company entity number': 'Company entity number',
  Email: 'Email',
  IBAN: 'IBAN',
  Relation: 'Relation',
  'Submitting application': 'Submitting application',
  'Please make sure that you verified the information in the tabs and representatives selected as authorized signatories have a record in the National Information Center for successful registration on the portal and subsequent confirmation of the signed contract. You will not be able to change the application data after submitting.':
    'Please make sure that you verified the information in the tabs and representatives selected as authorized signatories have a record in the National Information Center for successful registration on the portal and subsequent confirmation of the signed contract. You will not be able to change the application data after submitting.',
  'Do you want to continue?': 'Do you want to continue?',
  Continue: 'Continue',
  Cancel: 'Cancel',
  'Correct application data': 'Correct application data',
  'Complete all steps to submit application': 'Complete all steps to submit application',
  'Submit application': 'Submit application',
  'Company details': 'Company details',
  Shareholders: 'Shareholders',
  'Please, fix application data': 'Please, fix application data',
  'Internal warning': 'Internal warning',
  'Something went wrong': 'Something went wrong',
  'You can’t proceed with this application due to data validation errors. Update the data placed in Thiqah and create a new application.':
    'You can’t proceed with this application due to data validation errors. Update the data placed in Thiqah and create a new application.',
  'Your will able to restart the onboarding process after the application is terminated automatically on the next day. In case of any questions contact <1>Customer support</1>.':
    'Your will able to restart the onboarding process after the application is terminated automatically on the next day. In case of any questions contact <1>Customer support</1>.',
  'You can’t proceed with this application due to data validation errors.':
    'You can’t proceed with this application due to data validation errors.',

  'Authorised Signatory Proof': 'Authorised Signatory Proof',
  'Select the document type': 'Select the document type',
  'Company name': 'Company name',
  'Upload a copy of the Power of Attorney showing this person as an authorised signatory':
    'Upload a copy of the Power of Attorney showing this person as an authorised signatory',
  'This person is listed on the Company License as part of the company ownership structure':
    'This person is listed on the Company License as part of the company ownership structure',
  "Please correct the authorized signatory’s Phone Number: The provided phone number is invalid according to the National Information Center's data. Ensure the phone number is entered correctly. If you have any questions, please contact <1>Customer support</1>.":
    "Please correct the authorized signatory’s Phone Number: The provided phone number is invalid according to the National Information Center's data. Ensure the phone number is entered correctly. If you have any questions, please contact <1>Customer support</1>.",
  "The provided phone number does not match the one listed in the National Information Center's record for the authorised signatory’s document. Change the phone number to the correct one.":
    "The provided phone number does not match the one listed in the National Information Center's record for the authorised signatory’s document. Change the phone number to the correct one.",

  // PEP Modal
  'Who is a Politically Exposed Person (PEP)?': 'Who is a Politically Exposed Person (PEP)?',
  'A PEP is an individual who is or has been entrusted with a prominent public role, including:':
    'A PEP is an individual who is or has been entrusted with a prominent public role, including:',
  'Head of state or government, ministers, deputy or assistant ministers':
    'Head of state or government, ministers, deputy or assistant ministers',
  'Senior government or judicial officials': 'Senior government or judicial officials',
  'Members of parliament or senior politicians': 'Members of parliament or senior politicians',
  'Senior officials of political parties': 'Senior officials of political parties',
  'Members of courts of auditors or central bank boards':
    'Members of courts of auditors or central bank boards',
  'Ambassadors or high-ranking diplomats': 'Ambassadors or high-ranking diplomats',
  'Senior military officers': 'Senior military officers',
  'Senior executive or supervisory bodies of state-owned enterprises':
    'Senior executive or supervisory bodies of state-owned enterprises',
  'Also Considered PEPs:': 'Also Considered PEPs:',
  'Direct family members, including:': 'Direct family members, including:',
  'Spouse or partner (as recognized by law)': 'Spouse or partner (as recognized by law)',
  'Children and their spouses': 'Children and their spouses',
  'Parents.': 'Parents.',
  'Close associates, including:': 'Close associates, including:',
  'Individuals with joint ownership or close business ties with the PEP':
    'Individuals with joint ownership or close business ties with the PEP',
  "Beneficiaries of entities established for the PEP's benefit":
    "Beneficiaries of entities established for the PEP's benefit",
  'Note: Family members and close associates of a PEP are also considered PEPs':
    'Note: Family members and close associates of a PEP are also considered PEPs',
  'Note:': 'Note:',
  'Family members and close associates of a PEP are also considered PEPs':
    'Family members and close associates of a PEP are also considered PEPs',

  // Sanctioned Countries Modal
  'Sanctioned Countries, Territories and Individuals':
    'Sanctioned Countries, Territories and Individuals',
  'Sanctioned Countries/Territories:': 'Sanctioned Countries/Territories:',
  "Iran, Syria, Cuba, North Korea (Democratic People's Republic of Korea), Crimea, Sevastopol, Donetsk, Luhansk, and any other regions designated by relevant authorities.":
    "Iran, Syria, Cuba, North Korea (Democratic People's Republic of Korea), Crimea, Sevastopol, Donetsk, Luhansk, and any other regions designated by relevant authorities.",
  'Sanctioned Parties:': 'Sanctioned Parties:',
  'Includes individuals or entities listed by the United Nations Security Council, the European Union, the U.S. Office of Foreign Assets Control (OFAC), the UK HMT, or the UAE Supreme Council for National Security (Local Terrorist List).':
    'Includes individuals or entities listed by the United Nations Security Council, the European Union, the U.S. Office of Foreign Assets Control (OFAC), the UK HMT, or the UAE Supreme Council for National Security (Local Terrorist List).',
  'Note:  This list may be updated periodically by the relevant authorities.':
    'Note:  This list may be updated periodically by the relevant authorities.',
  'This list may be updated periodically by the relevant authorities.':
    'This list may be updated periodically by the relevant authorities.',

  Add: 'Add',

  // Agreement Review Section (after contract is loaded)
  'Review your agreement.': 'Review your agreement.',
  'Ecom': 'Ecom',
  'POS': 'POS',
  'Authorized Signatory details': 'Authorized Signatory details',
  'I confirm that I have read, understood and agree to be bound by Network International\'s Terms & Conditions.':
    'I confirm that I have read, understood and agree to be bound by Network International\'s Terms & Conditions.',
  'I have read, understood and agreed to the Merchant Terms and Conditions and Privacy Notice':
    'I have read, understood and agreed to the Merchant Terms and Conditions and Privacy Notice',
  'Review Terms and Conditions': 'Review Terms and Conditions',
  'I acknowledge that I have read the fees and charges and confirm that I have read and understood its contents prior to submitting this application.':
    'I acknowledge that I have read the fees and charges and confirm that I have read and understood its contents prior to submitting this application.',
  'View Fees and charges': 'View Fees and charges',
  Submit: 'Submit',
  'Contact us': 'Contact us',

  // Signatory Details modal
  'Merchant Name': 'Merchant Name',
  'Authorized Name': 'Authorized Name',
  'Commercial Registration No.': 'Commercial Registration No.',
  'Unified Number': 'Unified Number',

  // Terms & Conditions modal
  'Terms & Conditions': 'Terms & Conditions',
  'Terms and Conditions of Use. Ownership of Network Platform': 'Terms and Conditions of Use. Ownership of Network Platform',
  'I Agree': 'I Agree',
  'These Terms and Conditions of Use (the "Terms of Use") apply to the Network web site located at www.network.ae, and all associated sites linked to www.network.ae by Network, its subsidiaries and affiliates, including Network sites around the world. Network is the operator of the Network Platform (the "App") call center and other technology platforms (collectively, the "Network Platform"). The Network Platform is the property of Network International LLC ("Network") and/or its licensors.':
    'These Terms and Conditions of Use (the "Terms of Use") apply to the Network web site located at www.network.ae, and all associated sites linked to www.network.ae by Network, its subsidiaries and affiliates, including Network sites around the world. Network is the operator of the Network Platform (the "App") call center and other technology platforms (collectively, the "Network Platform"). The Network Platform is the property of Network International LLC ("Network") and/or its licensors.',
  'BY USING THE NETWORK PLATFORM, YOU AGREE TO THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE, DO NOT USE THE NETWORK PLATFORM. IF YOU ARE A NETWORK CUSTOMER, THE DEFINITIVE AGREEMENT SIGNED BETWEEN YOU AND NETWORK SHALL ALSO GOVERN THE USAGE OF THE NETWORK PLATFORM.':
    'BY USING THE NETWORK PLATFORM, YOU AGREE TO THESE TERMS AND CONDITIONS. IF YOU DO NOT AGREE, DO NOT USE THE NETWORK PLATFORM. IF YOU ARE A NETWORK CUSTOMER, THE DEFINITIVE AGREEMENT SIGNED BETWEEN YOU AND NETWORK SHALL ALSO GOVERN THE USAGE OF THE NETWORK PLATFORM.',
  "Network reserves the right, at its sole discretion, to change, modify, add or remove portions of these Terms of Use, at any time. It is your responsibility to check these Terms of Use periodically for changes. Your continued use of the Network Platform following the posting of changes will mean that you accept and agree to the changes. As long as you comply with these Terms of Use, Network grants you a personal, non-exclusive, non-transferable, limited privilege to enter and use the Network Platform on your personal device.":
    "Network reserves the right, at its sole discretion, to change, modify, add or remove portions of these Terms of Use, at any time. It is your responsibility to check these Terms of Use periodically for changes. Your continued use of the Network Platform following the posting of changes will mean that you accept and agree to the changes. As long as you comply with these Terms of Use, Network grants you a personal, non-exclusive, non-transferable, limited privilege to enter and use the Network Platform on your personal device.",
  'The Network Platform is intended for use only by persons who are residents of, and physically located within, the Kingdom of Saudi Arabia. By using the Network Platform, you represent and warrant that you satisfy this requirement. If you do not satisfy this requirement, please do not use the Network Platform.':
    'The Network Platform is intended for use only by persons who are residents of, and physically located within, the Kingdom of Saudi Arabia. By using the Network Platform, you represent and warrant that you satisfy this requirement. If you do not satisfy this requirement, please do not use the Network Platform.',

  // Fees drawer
  'Fees and charges': 'Fees and charges',
  'Service Fee': 'Service Fee',
  Waived: 'Waived',
  'Fees VAT label': 'VAT:',
  'All prices are VAT excluded': 'All prices are VAT excluded',
  'No fees information available.': 'No fees information available.',

  // Bank account - file upload error codes
  BAD_PROVIDED_FILE_en: 'Bank Proof Letter format is not supported',
  BAD_PROVIDED_FILE_ar: 'صيغة خطاب إثبات الحساب البنكي غير مدعومة',

  // Error Modal
  'Issue Encountered': 'Issue Encountered',
  'Try Again': 'Try Again',


  // Start in minutes module

  "Start in minutes": "Start in minutes",
  "Complete your onboarding in a few simple steps, no documents required.": "Complete your onboarding in a few simple steps, no documents required.",
  "Steps": "Steps",
  "Basic Information": "Basic Information",
  "National ID/Iqama and Unified National Number": "National ID/Iqama and Unified National Number",
  "Company Details": "Company Details",
  "Auto-filled from official records": "Auto-filled from official records",
  "Bank Details Start": "Bank Details",
  "Add your IBAN securely": "Add your IBAN securely",
  "Agreement Start": "Agreement",
  "Agreement": "Agreement",
  "Review and sign digitally": "Review and sign digitally",
  "Identity Verification": "Identity Verification",
  "Secure verification via Nafath": "Secure verification via Nafath",
  "All your data is protected in accordance with the highest security standards and regulations adopted in the Kingdom of Saudi Arabia.": "All your data is protected in accordance with the highest security standards and regulations adopted in the Kingdom of Saudi Arabia.",
  "Start Now": "Start Now",
  "Something went wrong. Please go back and try again.": "Something went wrong. Please go back and try again.",
  "Something went wrong. Please try again.": "Something went wrong. Please try again.",

  // Nafath CONFIRMATION step (new design)
  'Verify via Nafath': 'Verify via Nafath',
  'By continuing, you accept to verify your identity through Nafath services.':
    'By continuing, you accept to verify your identity through Nafath services.',
  'Please ensure the provided IBAN number is linked to your commercial registration number.':
    'Please ensure the provided IBAN number is linked to your commercial registration number.',
  'Enter IBAN Number': 'Enter IBAN Number',
  'Please provide proof of your IBAN by uploading a stamped IBAN letter that includes the UN/CR Number and is issued within the last year':
    'Please provide proof of your IBAN by uploading a stamped IBAN letter that includes the UN/CR Number and is issued within the last year',

  // Fees & Charges popup — tab labels
  'eCommerce_tab_label': 'Ecommerce',
  'POS_tab_label': 'POS',
  // Risk Questionnaire step
  'Risk Questionnaire': 'Risk Questionnaire',
  'Provide these answers based on your business':
    'Provide these answers based on your business',
  'Expected number of transactions per month': 'How much sales do you expect per month?',
  'Expected monthly sales amount ({SAR})': 'What is your expected monthly sales amount?({SAR})',
  'Expected average transaction value ({SAR})': 'What is your average order value?({SAR})',
  'Expected annual revenue ({SAR})': 'What is your estimated annual revenue?({SAR})',
  'This field is required': 'This field is required',
  'Issue date can not be in the future': 'Issue date can not be in the future',
  'Please enter a valid issue date': 'Please enter a valid issue date',
  'Please enter a valid expiry date': 'Please enter a valid expiry date',
  'Expiry date can not be in the past': 'Expiry date can not be in the past',
  'Maximum 150 characters.': 'Maximum 150 characters.',
  'The Iban verification failed.': 'The Iban verification failed.',
  'Download File': 'Download File',
  'Zero Monthly Fees for the First 3 Months ,Valid until <strong>28 September 2026*</strong>':
    'Zero Monthly Fees for the First 3 Months ,Valid until <strong>28 September 2026*</strong>',

  // ── Tamara / Tabby — Additional payment options (Products page) ──────────────
  'Additional payment option': 'Additional payment option',
  'Tamara': 'Tamara',
  'Tabby': 'Tabby',
  'Provide users option to choose BNPL upon payment -':
    'Provide users option to choose BNPL upon payment -',
  'Tabby and Tamara require separate onboarding with the respective provider.':
    'Tabby and Tamara require separate onboarding with the respective provider.',
};
